import React from 'react';
import { Notification } from 'baseui/notification';
import { useStyletron } from 'baseui';
import { Check } from 'baseui/icon'; // Corrected import

const SuccessNotificationComponent = ({ message }) => {
  const [css, theme] = useStyletron();

  return (
    <Notification
      kind="positive"
      overrides={{
        Body: { style: { width: 'auto' } }
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Check size={36} color={theme.colors.positive} /> {/* Updated icon usage */}
        <span style={{ marginLeft: '10px', fontSize: "14px" }}>{message}</span>
      </div>
    </Notification>
  );
};

export default SuccessNotificationComponent;
